module.exports = __webpack_public_path__ + "04bf8891b2de67b2159a6f8548d08fb7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/NC.svg
// module id = L4EI
// module chunks = 0